import styled from '@emotion/styled';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import cnscImg from '../assets/cnsc.png';

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 10px;
  background-color: #f7f9fa;

  & > img {
    width: 186px;
  }
`;

const Content = styled.div`
  flex: 1;
  margin-top: 100px;
  margin-left: 14px;

  & > strong {
    margin-top: 28px;
  }
`;

const Label = styled.div`
  margin-bottom: 28px;
`;

export enum StorehouseType {
  // 官方仓
  Official = 1,
  // 第三方仓
  External,
}

/**
 * 店铺类型V2，合并 3PF
 *
 * PD：https://leyan.yuque.com/czpqnb/pd/ohezvbqx9qkd9c33#t1iWF
 */
export enum ShopTypeEnum {
  // 跨境店（官方仓）
  CrossOfficial = 'CrossOfficial',
  // 跨境店（3PF）
  Cross3PF = 'Cross3PF',
  // 本土店
  Local = 'Local',
}

export interface ShopeeCNSCGuideProps {
  shopType?: ShopTypeEnum;
  storehouseType?: StorehouseType;
}

const ShopeeCNSCGuide = (props: ShopeeCNSCGuideProps) => {
  const { shopType } = props;
  const { t } = useTranslate();

  const imgSrc = useMemo(() => {
    if (shopType === ShopTypeEnum.CrossOfficial) return cnscImg;
    if (shopType === ShopTypeEnum.Cross3PF) return cnscImg;

    return null;
  }, [shopType]);

  if (shopType === ShopTypeEnum.Local) {
    return null;
  }

  return (
    <Container>
      {imgSrc ? <img src={imgSrc} alt="" /> : null}
      <Content>
        {shopType === ShopTypeEnum.CrossOfficial ? (
          <>
            <Label>{t('authShop.添加官方仓店铺时，请在打开的授权页面点击')}</Label>
            <strong>
              <div>[Switch to Main Account]</div>
              <div>{t('authShop.点击此按钮，输入子母帐号密码')}</div>
            </strong>
          </>
        ) : null}
        {shopType === ShopTypeEnum.Cross3PF ? (
          <>
            <Label>
              {t('authShop.添加第三方仓库(3PF)店铺时，请在打开的授权页面输入店铺帐号密码')}
            </Label>
            <strong>
              <div>[Switch to Main Account]</div>
              <div>{t('authShop.点击此按钮，输入子母帐号密码')}</div>
            </strong>
          </>
        ) : null}
      </Content>
    </Container>
  );
};

export default ShopeeCNSCGuide;
